<div [style.width.px]="sidebarWidth"
     class="sidebar" (window:resize)="onResize()">
    <div class="sidebar-content">
      <div class="py-6 px-1 flex items-center justify-center logo">
          <div class="logo">
              <div class="text-textDark text-15 font-medium flex items-center">
                <div class="logo-img">
                  <img src="../../../../../assets/img/logo-projects/Logo.png">
                </div>
              </div>
          </div>
      </div>
      <ul #styleLeft nz-menu nzMode="vertical" id="style-2" [nzInlineIndent]="'5'" style="overflow-x: hidden; overflow-y: auto;" [style.height.px]="height">
        <ng-container *ngFor="let link of sideBarLinks; let idx = index">
          <li *ngIf="!link.subTabs.length" class="menu-name" [nzSelected]="link.idTab === 'board'" nz-menu-item (click)="onOpenTab(link)">
              <i nz-icon [nzType]="link.icon" nzTheme="outline"></i>
              {{ link.title }}
          </li>
          <li class="menu-sidebar" *ngIf="link.subTabs.length" nz-submenu [nzTitle]="link.title" [nzIcon]="link.icon" [nzMenuClassName]="
          (link.id === 34 && (userInfo.accountType === 5 || userInfo.accountType === 6 )) ||  (link.id === 23 && (userInfo.accountType === 5 || userInfo.accountType === 6 )) ? 'fix-outside-menu': ''">
            <ul>
              <ng-container *ngFor="let sub of link.subTabs">
                <li class="menu-name-2" *ngIf="!sub.subTabs.length" nz-menu-item (click)="onOpenTab(sub)">
                  {{ sub.title }}
                </li>
                <li *ngIf="sub.subTabs.length" nz-submenu [nzTitle]="sub.title">
                  <ul>
                    <ng-container *ngFor="let sub3 of sub.subTabs">
                      <li class="menu-name-2" *ngIf="!sub3.subTabs.length" nz-menu-item (click)="onOpenTab(sub3)">
                        {{ sub3.title }}
                      </li>
                      <li class="menu-name-2" *ngIf="sub3.subTabs" nz-submenu [nzTitle]="sub3.title">
                        <ul>
                          <ng-container *ngFor="let sub4 of sub.subTabs">
                            <li class="menu-name-2" nz-menu-item (click)="onOpenTab(sub4)">
                              {{ sub4.title }}
                            </li>
                          </ng-container>
                        </ul>
                      </li>
                    </ng-container>
                  </ul>
                </li>
              </ng-container>

            </ul>
          </li>
        </ng-container>
        <!-- <li class="menu-name" nz-menu-item (click)="onOpenMail()">
          <i nz-icon [nzType]="'mail'" nzTheme="outline"></i>
          Hộp thư
        </li> -->
      </ul>
    <div>
      <div class="user-menu {{hasScrollbar ? 'usermenuscroll' : ''}}"  >
        <ul nz-menu nzMode="horizontal" class="user-gp">
          <li nz-menu-item nz-dropdown [nzTrigger]="'click'" [nzDropdownMenu]="menuUser"
            [nzPlacement]="'topLeft'">
            <nz-avatar nzIcon="user" [nzSrc]="userInfo.avatar"></nz-avatar>
            <span>
              {{userInfo.fullName}}
            </span>
          </li>
          <li nz-menu-item #elItem style="margin: 0 !important;">
          </li>
        </ul>
        <nz-dropdown-menu #menuUser="nzDropdownMenu">
          <ul nz-menu nzSelectable>
            <li nz-menu-item *ngFor="let item of userItems" (click)="item.handler()">
              <i
                nz-icon
                [nzType]="item.icon"
                nzTheme="outline"
                >
              </i>
              {{ item.tooltip }}
            </li>
            <hr>
            <li nz-menu-item (click)="logout()"><i nz-icon nzType="logout" nzTheme="outline"></i>Đăng xuất</li>
          </ul>
        </nz-dropdown-menu>
      </div>
    </div>
  </div>
</div>
